import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Section } from "./section";

export function TypographySection() {
	return (
		<Section title="Typografia">
			<Card>
				<CardContent className="flex flex-col gap-4 pt-6">
					<div className="flex flex-col gap-1">
						<p className="text-xs text-muted-foreground font-mono">
							text-3xl font-bold
						</p>
						<p className="text-3xl font-bold">Nagłówek H1</p>
					</div>
					<div className="flex flex-col gap-1">
						<p className="text-xs text-muted-foreground font-mono">
							text-2xl font-semibold
						</p>
						<p className="text-2xl font-semibold">Nagłówek H2</p>
					</div>
					<div className="flex flex-col gap-1">
						<p className="text-xs text-muted-foreground font-mono">
							text-xl font-semibold
						</p>
						<p className="text-xl font-semibold">Nagłówek H3</p>
					</div>
					<div className="flex flex-col gap-1">
						<p className="text-xs text-muted-foreground font-mono">
							text-lg font-medium
						</p>
						<p className="text-lg font-medium">Nagłówek H4</p>
					</div>
					<Separator />
					<div className="flex flex-col gap-1">
						<p className="text-xs text-muted-foreground font-mono">text-base</p>
						<p className="text-base">
							Tekst podstawowy — Inter Variable, 16px. Lorem ipsum dolor sit
							amet, consectetur adipiscing elit. Sed do eiusmod tempor
							incididunt.
						</p>
					</div>
					<div className="flex flex-col gap-1">
						<p className="text-xs text-muted-foreground font-mono">
							text-sm text-muted-foreground
						</p>
						<p className="text-sm text-muted-foreground">
							Tekst pomocniczy — mniejszy, wyciszony kolor.
						</p>
					</div>
					<div className="flex flex-col gap-1">
						<p className="text-xs text-muted-foreground font-mono">
							text-xs font-mono
						</p>
						<p className="text-xs font-mono">
							0x1A2B3C — mono, np. kody, wartości
						</p>
					</div>
				</CardContent>
			</Card>
		</Section>
	);
}
